/* Japanese initialisation for the jQuery UI date picker plugin. */
/* Written by Kentaro SATO (kentaro@ranvis.com). */
(function (factory) {
	"use strict";

	if (typeof define === "function" && define.amd) {

		// AMD. Register as an anonymous module.
		define(["../widgets/datepicker"], factory);
	} else {

		// Browser globals
		factory(jQuery.datepicker);
	}
})
	(function (datepicker) {
		"use strict";

		datepicker.regional.ja = {
			closeText: "閉じる",
			prevText: "前",
			nextText: "次",
			currentText: "今日",
			monthNames: ["1月", "2月", "3月", "4月", "5月", "6月",
				"7月", "8月", "9月", "10月", "11月", "12月"],
			monthNamesShort: ["1月", "2月", "3月", "4月", "5月", "6月",
				"7月", "8月", "9月", "10月", "11月", "12月"],
			dayNames: ["日曜日", "月曜日", "火曜日", "水曜日", "木曜日", "金曜日", "土曜日"],
			dayNamesShort: ["日", "月", "火", "水", "木", "金", "土"],
			dayNamesMin: ["日", "月", "火", "水", "木", "金", "土"],
			weekHeader: "週",
			dateFormat: "yy/mm/dd",
			firstDay: 0,
			isRTL: false,
			showMonthAfterYear: true,
			yearSuffix: "年"
		};
		datepicker.setDefaults(datepicker.regional.ja);

		return datepicker.regional.ja;

	});
